import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const links = [
  { path: '/', label: 'Home' },
  { path: '/about', label: 'About' },
  { path: '/geotechnical', label: 'Geotechnical' },
  { path: '/materials', label: 'Materials' },
  { path: '/equipment', label: 'Equipment' },
  { path: '/careers', label: 'Careers' },
  { path: '/contact', label: 'Contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location]);

  const navStyle = {
    position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
    padding: scrolled ? '12px 0' : '20px 0',
    background: scrolled ? 'rgba(253,248,240,0.95)' : 'transparent',
    backdropFilter: scrolled ? 'blur(12px)' : 'none',
    boxShadow: scrolled ? '0 2px 20px rgba(0,0,0,0.06)' : 'none',
    transition: 'all 0.4s ease',
  };

  return (
    <nav style={navStyle}>
      <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{
            width: 42, height: 42, background: 'var(--primary)', color: 'white',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontFamily: "'Playfair Display', serif", fontSize: '1.4rem', fontWeight: 700, borderRadius: 8
          }}>H</div>
          <div>
            <div style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.15rem', fontWeight: 700, color: 'var(--primary-dark)', letterSpacing: 1 }}>HICON</div>
            <div style={{ fontSize: '0.68rem', color: 'var(--text-light)' }}>Testing Lab & Research</div>
          </div>
        </Link>

        {/* Desktop nav */}
        <div style={{ display: 'flex', gap: 4 }} className="desktop-nav">
          {links.map(l => (
            <Link key={l.path} to={l.path} style={{
              padding: '8px 16px', fontSize: '0.88rem', fontWeight: location.pathname === l.path ? 500 : 400,
              color: location.pathname === l.path ? 'var(--primary)' : 'var(--text-mid)',
              borderBottom: location.pathname === l.path ? '2px solid var(--primary)' : '2px solid transparent',
              transition: 'all 0.2s'
            }}>
              {l.label}
            </Link>
          ))}
        </div>

        {/* Hamburger */}
        <button onClick={() => setOpen(!open)} className="hamburger" aria-label="Menu" style={{
          display: 'none', flexDirection: 'column', gap: 5, background: 'none', border: 'none', cursor: 'pointer', padding: 8
        }}>
          <span style={{ width: 24, height: 2, background: 'var(--primary-dark)', borderRadius: 2, transition: 'all 0.3s', transform: open ? 'rotate(45deg) translate(5px,5px)' : 'none' }}></span>
          <span style={{ width: 24, height: 2, background: 'var(--primary-dark)', borderRadius: 2, transition: 'all 0.3s', opacity: open ? 0 : 1 }}></span>
          <span style={{ width: 24, height: 2, background: 'var(--primary-dark)', borderRadius: 2, transition: 'all 0.3s', transform: open ? 'rotate(-45deg) translate(5px,-5px)' : 'none' }}></span>
        </button>
      </div>

      {/* Mobile menu */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="mobile-nav"
            style={{ background: 'rgba(253,248,240,0.98)', padding: '8px 24px 24px', overflow: 'hidden' }}
          >
            {links.map(l => (
              <Link key={l.path} to={l.path} style={{
                display: 'block', padding: '14px 0', fontSize: '1rem',
                color: location.pathname === l.path ? 'var(--primary)' : 'var(--text-mid)',
                fontWeight: location.pathname === l.path ? 600 : 400,
                borderBottom: '1px solid var(--border)'
              }}>{l.label}</Link>
            ))}
          </motion.div>
        )}
      </AnimatePresence>

      <style>{`
        @media (max-width: 900px) {
          .desktop-nav { display: none !important; }
          .hamburger { display: flex !important; }
        }
        @media (min-width: 901px) {
          .mobile-nav { display: none !important; }
        }
      `}</style>
    </nav>
  );
}
